import React from 'react';
import classes from './skeleton.module.css';

const Skeleton = ({ width, height }) => {
    return <div className={classes.skeleton} style={{ width, height }}></div>;
};

export default Skeleton;
